import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import style from "../styles/Login.module.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContextProvider";
import { auth } from "../Authentication";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useContext } from "react";
import { Alert } from "@mui/material";
const initState = { email: "", password: "" };

// const newAlert = () => {
//   return <Alert >Login Succesful</Alert>;
// };
function Login() {
  const navigate = useNavigate();
  const { isAuth, Login, Logout, UserDetails, setUserDetails } =
    useContext(AuthContext);
  const [formState, setFormset] = useState(initState);

  const handleclick = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password).then(
        (userCredential) => {
          Login(userCredential);
          alert("Login SuccessFull");
        }
      );
    } catch (error) {
      alert("wrong Crendtial");
    }
  };

  const handleChange = (e) => {
    setFormset({ ...formState, [e.target.name]: e.target.value });
  };

  const { email, password } = formState;

  if (isAuth) {
    setTimeout(() => {
      return navigate("/");
    }, 2000);
  }

  return (
    <>
      <div className={style.empty_cont_login}></div>

      <div className={style.login_main}>
        <div className={style.login_image}>
          <img
            width="60%"
            src="https://russdigital.netlify.app/login.jpg"
            alt=""
          />
        </div>
        <div className={style.form_cont}>
          <h1>Sign to your Account</h1>
          <p>
            New to website? please{" "}
            <Link className={style.goto_signup} to="/signup">
              SignUp Here
            </Link>
          </p>
          <div>
            <form>
              <label>Email</label>
              <input
                onChange={handleChange}
                type="email"
                name="email"
                value={email}
                placeholder="Enter your Email"
              />

              <br />
              <label>Password</label>
              <input
                onChange={handleChange}
                type="password"
                name="password"
                value={password}
                placeholder="Enter your Password"
              />
              <br />
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "13px",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <input className={style.remember_check} type="checkbox" />
                    </div>
                    <div>
                      <span>Remember me</span>
                    </div>
                  </div>
                  <p className={style.forgot_pass}>Forgot Password</p>
                </div>
              </div>
              <button
                className={style.login_BTN}
                type="submit"
                onClick={handleclick}
                value="submit"
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
